import { ScopeVO } from '../../value-object/ScopeVO'

/**
 * パーミッションポリシーエンティティ
 */
export type PermissionPolicyEntity = {
  uuid: string
  name: string
  description?: string
  type: string
  attachable: boolean
  attachedByDefault: boolean
  scopes: ScopeVO[]
}

// Services
const isAttachedByDefault = (
  permissionPolicy: Pick<PermissionPolicyEntity, 'attachedByDefault'>
) => permissionPolicy.attachedByDefault

const isAttachable = (
  permissionPolicy: Pick<PermissionPolicyEntity, 'attachable'>
) => permissionPolicy.attachable

export const permissionPolicyService = {
  isAttachedByDefault,
  isAttachable,
}
